import { Box, IconButton, Paper, Stack, Typography, Chip } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { LoyaltyRule } from "../rules";

interface Props {
  rule: LoyaltyRule;
  onEdit?: () => void;
  onDelete?: () => void;
  isActive?: boolean;
}

const LoyaltyRulesCard: React.FC<Props> = ({
  rule,
  onEdit,
  onDelete,
  isActive
}) => {
  return (
    <Paper elevation={2} sx={{ p: 3, borderRadius: 2, mt: 2 }}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Box>
          <Typography variant="h6">Loyalty Rule Details</Typography>
          {isActive && (
            <Chip label="Active" color="success" size="small" sx={{ mt: 1 }} />
          )}
        </Box>
        <Box>
          <IconButton onClick={onEdit} color="primary">
            <EditIcon />
          </IconButton>
          <IconButton onClick={onDelete} color="error">
            <DeleteIcon />
          </IconButton>
        </Box>
      </Box>
      <Stack spacing={2}>
        <Typography>🎯 Points per ₹{rule.pointsPerAmount}: 1 point</Typography>
        <Typography>
          💎 Redeem Value per Point: ₹{rule.redeemValuePerPoint}
        </Typography>
        <Typography>
          👥 Referral Bonus Points: {rule.referralBonusPoints}
        </Typography>
        <Typography>📅 Points Expiry (days): {rule.expiryDays}</Typography>
      </Stack>
    </Paper>
  );
};

export default LoyaltyRulesCard;
